const documentTypeName = {
  medicalReport: 'Medical report',
  medicalForm: 'Medical form',
  dentalReport: 'Dental report',
  incidentReport: 'Incident report',
} as const;

export { documentTypeName };
